import { EAction } from '~/src/features/internetV2/constants/actions';
import { TArticle } from '~/src/features/internetV2/store/reducer';
import { IAction } from '~/src/store';

type TPayload = Record<string, TArticle>;

const setArticles = (payload: TPayload): IAction<EAction.SetArticles, TPayload> => ({
    type: EAction.SetArticles,
    payload,
});

export default setArticles;
